import * as types from './types'
import storage from '@/plugins/storage'
export default () => ({
  default: {
    firm: 0,
    testdrive: null,
    testdriveType: 0,
    contact: 0,
    fleetNumber: '',
    insurance: 0,
    invoiceNumber: '',
    notes: '',
    ronumber: '',
    vehicle: {
      vehicle: -1,
      firm: 0,
      contact: 0,
      year: 2010,
      make: 0,
      model: '',
      vin: ''
    },
    createdBy: 0,
    status: 1
  },
  defaultDrive: {
    firm: 0,
    firmName: '',
    testDriveDrive: null,
    testDrive: null,
    roNumber: '',
    driveType: 0,
    driveTypeName: '',
    driveName: '',
    techs: [],
    distanceStart: 0,
    distanceEnd: 0,
    speedMin: 0,
    speedMax: 0,
    driveStart: new Date(),
    driveEnd: new Date(),
    technicianContact: 0,
    weather: null,
    notes: null,
    videoUrl: null
  },
  defaultWaypoint: {
    testdrivewaypoint: null,
    testdrivedrive: null,
    testdrive: null,
    time: new Date(),
    speed: 0,
    latitude: 0,
    longitude: 0
  },
  pageSize: storage.session.getItem(types.TESTDRIVE_PAGE_SIZE) || 10,
  searchTerm: storage.session.getItem(types.TESTDRIVE_SEARCH_TERM) || '',
  sortDir: storage.session.getItem(types.TESTDRIVE_SORT_DIR) || 'desc',
  orderBy: storage.session.getItem(types.TESTDRIVE_ORDER_BY) || 'TestDrive',
  filterBy: parseInt(storage.local.getItem(types.TESTDRIVE_FILTER_BY)) || null,
  filterOptions: [],
  testdrives: [],
  testdrive: null,
  testdrivedrives: [],
  testdrivedrive: null,
  highlightSave: false,
  isTestDriveChecked: false,
  testdrivewaypoints: [],
  testdrivewaypoint: null,
  weather: null,
  videolink: null,
  testdriveTypeRates: [],
  testdriveResults: [],
  reportPreference: null
})



// WEBPACK FOOTER //
// ./src/store/modules/testdrives/state.js